import React from 'react';
import { AudienceSwitch } from '../components/AudienceSwitch';
import { BenefitsBento } from '../components/BenefitsBento';
import { ClosingCTA } from '../components/ClosingCTA';
import { ContextGraph } from '../components/ContextGraph';
import { GettingStartedSteps } from '../components/GettingStartedSteps';
import { MemoryCarousel } from '../components/MemoryCarousel';
import { NarrativeSection } from '../components/NarrativeSection';
import { TeamSlackWorkspace } from '../components/TeamSlackWorkspace';
import { TeamWorkspaceHero } from '../components/TeamWorkspaceHero';
import { WallOfLove } from '../components/WallOfLove';
/**
 * Experimental home-page direction for reviewing a stronger team-workspace
 * narrative. The production home page remains unchanged at /.
 */
export function HomeTeamWorkspace() {
  return <div className="team-workspace" data-id="element-9556" data-mp="imsqq9p7govg">
      <TeamWorkspaceHero data-id="element-9557" data-mp="ipwzzlhj2asz" />
      <BenefitsBento teamWorkspace actionHeadline="Automate the busywork" actionBody="Turn recurring updates, handoffs, and follow-ups into flows Giga runs for you." data-id="element-9558" data-mp="nm5mxl1yv8ap" />
      <TeamSlackWorkspace data-id="element-9559" data-mp="418dqd1q48l9" />
      <GettingStartedSteps data-id="element-9560" data-mp="3v9du97z8k99a" />
      <AudienceSwitch headline="More than a work assistant." data-id="element-9561" data-mp="3vb72ustet3jx" />
      <ContextGraph headline={<>
            One shared <span className="text-[#EA580C]" data-id="element-9563" data-mp="3r6qxqtrme05r">context graph</span>
            <br className="hidden md:block" data-id="element-9564" data-mp="3ma0iu9rjxalx" /> for the whole team.
          </>} subhead="Query Every conversation, decision, and source of truth from one place" data-id="element-9562" data-mp="3r8214sh5l5wc" />
      <MemoryCarousel headline="Shared context, tailored to you." subhead="Giga connects the team's knowledge, while learning your individual priorities, your network, and exactly how you like to work." data-id="element-9565" data-mp="3hbz0jr1y9fbi" />
      <WallOfLove data-id="element-9566" data-mp="37hypz9nwfhve" />
      <NarrativeSection data-id="element-9567" data-mp="33izhxg6vf4zq" />
      <ClosingCTA data-id="element-9568" data-mp="33jr4y2mejuee" />
    </div>;
}